import {
  FOUNDATION_ALL_RFI_ID,
  isFoundationAllLabel,
  makeFoundationAllSelection,
} from "./foundationScope";
import { getRfiCapabilityBadgeDisplayName } from "./rfiCatalogServiceNames";

/** Foundation - All / Core Capabilities first; otherwise leave secondary sort to the caller. */
export function compareFoundationFirst(labelA, labelB) {
  if (isFoundationAllLabel(labelA)) return -1;
  if (isFoundationAllLabel(labelB)) return 1;
  return 0;
}

/** Sort string service names with Foundation first, then localeCompare. */
export function sortServiceCategoryNames(names = []) {
  return [...(names || [])].sort((a, b) => {
    const foundation = compareFoundationFirst(a, b);
    if (foundation !== 0) return foundation;
    return String(a || "").localeCompare(String(b || ""));
  });
}

/**
 * Keep names that exist in the serviceColors map (raw or catalog display name),
 * then sort Foundation first.
 */
export function filterAndSortKnownServiceNames(names = [], serviceColors = {}) {
  const known = (names || [])
    .map((s) => (s || "").trim())
    .filter(
      (s) =>
        Boolean(s) &&
        (serviceColors[s] ||
          serviceColors[getRfiCapabilityBadgeDisplayName(s)])
    );
  return sortServiceCategoryNames(known);
}

/** Display label + color lookup for list/grid/chat badges. */
export function resolveServiceBadgePresentation(name, serviceColors = {}) {
  const trimmed = (name || "").trim();
  const displayName = getRfiCapabilityBadgeDisplayName(trimmed);
  const color = serviceColors[trimmed] || serviceColors[displayName];
  return { trimmed, displayName, color };
}

/** Whether a highlightedServices list matches the raw or display name. */
export function isServiceCategoryHighlighted(name, highlighted = []) {
  if (!Array.isArray(highlighted) || highlighted.length === 0) return false;
  const displayName = getRfiCapabilityBadgeDisplayName(name);
  return highlighted.includes(name) || highlighted.includes(displayName);
}

/** Always keep Foundation - All selected and non-removable in react-select values. */
export function withLockedFoundationSelection(selected = []) {
  return [
    makeFoundationAllSelection(),
    ...(Array.isArray(selected) ? selected : []).filter(
      (item) => item?.value !== FOUNDATION_ALL_RFI_ID
    ),
  ];
}

export function isFoundationMultiSelectOptionDisabled(option) {
  return option?.value === FOUNDATION_ALL_RFI_ID;
}

export function shouldHideFoundationMultiValueRemove(data) {
  return data?.value === FOUNDATION_ALL_RFI_ID;
}

/** Disable Foundation option in react-select option lists. */
export function mapOptionsWithFoundationDisabled(options = []) {
  return (options || []).map((option) => ({
    ...option,
    isDisabled: isFoundationMultiSelectOptionDisabled(option),
  }));
}

/** Drop Foundation from a selection before writing form state (value is re-locked). */
export function filterOutFoundationMultiSelectOptions(selected = []) {
  return (Array.isArray(selected) ? selected : []).filter(
    (item) => !isFoundationMultiSelectOptionDisabled(item)
  );
}
